import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5836e4c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "field-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_ctx.specialElement)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.fieldType), {
        key: 0,
        data: _ctx.data
      }, null, 8, ["data"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_item, {
          class: "big-form-item",
          lines: _ctx.itemWithLine ? 'full' : 'none'
        }, {
          default: _withCtx(() => [
            (_ctx.data.label)
              ? (_openBlock(), _createBlock(_component_ion_label, {
                  key: 0,
                  position: "stacked",
                  "text-wrap": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getLabel()), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.fieldType), {
              data: _ctx.data,
              onValueChanged: _ctx.handleChangedValue
            }, null, 40, ["data", "onValueChanged"]))
          ]),
          _: 1
        }, 8, ["lines"]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ion_icon, { icon: _ctx.arrowUpOutline }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
}